<template>
  <div class="container">
    <h2 class="text-center">
      {{ $t('gcupage.title') }}
    </h2>
    <div>
      <h3>{{ $t('gcupage.subtitle') }}</h3>
    </div>

    <h3>{{ $t('gcupage.definition.title') }}</h3>

    <p>
      <span>{{ $t('gcupage.definition.paragraph1') }}</span>
    </p>

    <p>
      <span>{{ $t('gcupage.definition.paragraph2') }}</span>
    </p>

    <ul>
      <li>
        <span>{{ $t('gcupage.definition.paragraph3') }}</span>
      </li>
      <li>
        <span>{{ $t('gcupage.definition.paragraph4') }}</span>
      </li>
    </ul>

    <p>
      <span>{{ $t('gcupage.definition.paragraph5') }}</span>
    </p>

    <p>
      <span>{{ $t('gcupage.definition.paragraph6') }}</span>
    </p>

    <h3>{{ $t('gcupage.availability.title') }}</h3>
    <p>
      <span>{{ $t('gcupage.availability.paragraph1') }}</span>
    </p>
    <p>
      <span>{{ $t('gcupage.availability.paragraph2') }}</span>
    </p>

    <h3>{{ $t('gcupage.commitments.title') }}</h3>
    <p>
      <span>{{ $t('gcupage.commitments.paragraph1') }}</span>
    </p>
    <p>
      <span>{{ $t('gcupage.commitments.paragraph2') }}</span>
    </p>

    <h3>{{ $t('gcupage.property.title') }}</h3>
    <p>
      <span>{{ $t('gcupage.property.paragraph1') }}</span>
    </p>

    <h3>{{ $t('gcupage.cookies.title') }}</h3>
    <p>
      <span>{{ $t('gcupage.cookies.paragraph1') }}</span>
    </p>

    <h3>{{ $t('gcupage.privacy.title') }}</h3>

    <p>
      <span>{{ $t('gcupage.privacy.paragraph1') }}</span>
    </p>

    <p>
      <span>{{ $t('gcupage.privacy.paragraph2') }}</span>
    </p>

    <p>
      <span>{{ $t('gcupage.privacy.paragraph3') }}</span>
    </p>

    <ul>
      <li>
        <span>{{ $t('gcupage.privacy.paragraph4') }}</span>
      </li>
      <li>
        <span>{{ $t('gcupage.privacy.paragraph5') }}</span>
      </li>
    </ul>

    <p>
      <span>{{ $t('gcupage.privacy.paragraph6') }}</span>
    </p>

    <p>
      <span>{{ $t('gcupage.privacy.paragraph7') }}</span>
    </p>

    <p>
      <span>{{ $t('gcupage.privacy.paragraph8') }}</span>
    </p>

    <p>
      <span>{{ $t('gcupage.privacy.paragraph9') }}</span>
    </p>

    <p>
      <span>{{ $t('gcupage.privacy.paragraph10.content') }}
        <a
          href="https://www.anfr.fr/contact/protection-des-donnees-personnelles-rgpd"
          target="“_blank"
        >
          {{ $t('gcupage.privacy.paragraph10.link') }}
        </a>
      </span>
    </p>
  </div>
</template>
<script>


export default {
  name: "CguComponent",
};
</script>
<style lang="scss" scoped>
span {
  font-family: "font-family, Verdana, Geneva, sans-serif";
}

p, span, li{
  font-size: smaller;
}
</style>
